// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ReportNetworkErrorHandler_errorContainer__8xOD-","errorIcon":"ReportNetworkErrorHandler_errorIcon__1VYde","errorText":"ReportNetworkErrorHandler_errorText__8Ae4g"};